/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// Disabling the above rules for now, should readdress to have better accessibility
import React from 'react';

import { useSelector } from 'react-redux';

import { useAppDispatch, useAppSelector } from 'utils/hooks';

import textNodes from 'domains/text_nodes';

import PassiveTextArea from './PassiveTextArea';
import TextToolbarSidebarFontSize from './TextToolsFontSize';
import TextToolbarSidebarFontFamily from './TextToolsFontFamily';
import TextToolbarSidebarColor from './TextToolsColor';
import TextToolbarSidebarTextAlign from './TextToolsTextAlign';
import TextToolbarSidebarTextVertical from './TextToolsVerticalAlign';

import type { TextAlignment } from 'domains/text_nodes';

function PassiveTextTools() {
  const dispatch = useAppDispatch();
  const activeTextNodeId = useSelector(textNodes.selectors.activeNode);
  if (!activeTextNodeId) {
    return <React.Fragment />;
  }
  const textNode = useAppSelector((state) =>
    textNodes.selectors.selectById(state, activeTextNodeId)
  );
  if (!textNode) {
    return <React.Fragment />;
  }
  const { autofit, fontSize, fontFamily, textColor, horizontalAlignment, verticalAlignment } =
    textNode || {};

  return (
    <React.Fragment>
      <div className="component-container">
        <div className="texttools__item text">
          <PassiveTextArea textNode={textNode} />
        </div>
      </div>
      <div className="component-details">
        <div className="texttools__item size">
          <TextToolbarSidebarFontSize
            autofit={!!autofit}
            size={Number(fontSize)}
            autofitCheck={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ autofit: v }));
            }}
            sizeChange={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ fontSize: v.toString() }));
            }}
          />
        </div>
        <div className="texttools__item font">
          <TextToolbarSidebarFontFamily
            family={fontFamily}
            selectFamily={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ fontFamily: v }));
            }}
          />
        </div>
        <div className="texttools__item align">
          <TextToolbarSidebarTextAlign
            value={horizontalAlignment}
            onClick={(v: TextAlignment) => {
              dispatch(textNodes.actions.changeActiveTextNode({ horizontalAlignment: v }));
            }}
          />
        </div>
        <div className="texttools__item vertical">
          <TextToolbarSidebarTextVertical
            value={verticalAlignment}
            onClick={(v: TextAlignment) => {
              dispatch(textNodes.actions.changeActiveTextNode({ verticalAlignment: v }));
            }}
          />
        </div>
        <div className="texttools__item color">
          <TextToolbarSidebarColor
            color={textColor}
            colorChange={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ textColor: v }));
            }}
            colorChoose={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ textColor: v }));
            }}
            colorCancel={(v) => {
              dispatch(textNodes.actions.changeActiveTextNode({ textColor: v }));
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default PassiveTextTools;
